"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getPrismicDocumentLang = function getPrismicDocumentLang(language) {
  switch (language) {
    case "pl":
      return "pl";
    case "en":
      return "en-gb";
    case "gb":
      return "en-gb";
    case "es":
      return "es-es";
    case "fr":
      return "fr-fr";
    case "de":
      return "de-de";
    case "it":
      return "it-it";
    case "ro":
      return "ro";
    case "se":
      return "sv-se";
    case "sk":
      return "sk";
    case "cz":
      return "cs-cz";
    case undefined:
      return "en-gb";
    default:
      return "en-gb";
  }
};
var _default = getPrismicDocumentLang;
exports["default"] = _default;